import GavelOutlinedIcon from "@mui/icons-material/GavelOutlined";
import HourglassEmptyOutlinedIcon from "@mui/icons-material/HourglassEmptyOutlined";
import RateReviewOutlinedIcon from "@mui/icons-material/RateReviewOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";

// Keyed on disputeResolutionStatus, the field the Dispute API documents as
// "the outcome" (its only 4 possible values). RESPONSE_NEEDED = merchant
// hasn't responded yet; UNDER_REVIEW = merchant rejected, admin can now rule;
// MERCHANT_WON / CUSTOMER_WON = final ruling via resolve-dispute.
export const CHARGEBACK_STATUS = {
  RESPONSE_NEEDED: {
    label: "Awaiting Merchant",
    bg: "#fffbeb",
    color: "#92400e",
  },
  UNDER_REVIEW: {
    label: "Ready For Review",
    bg: "#eff6ff",
    color: "#1e40af",
  },
  MERCHANT_WON: { label: "Merchant Won", bg: "#ecfdf5", color: "#065f46" },
  CUSTOMER_WON: { label: "Customer Won", bg: "#fef2f2", color: "#991b1b" },
};

// merchantStatus: the merchant's own side of the dispute, shown separately
// in the drawer regardless of the resolution-outcome chip above.
export const MERCHANT_RESPONSE_STATUS = {
  RESPONSE_NEEDED: { label: "Awaiting Response", bg: "#fffbeb", color: "#92400e" },
  ACCEPTED: { label: "Accepted", bg: "#ecfdf5", color: "#065f46" },
  REJECTED: { label: "Rejected", bg: "#fef2f2", color: "#991b1b" },
  NO_RESPONSE: { label: "No Response", bg: "#f3f4f6", color: "#374151" },
};

// Full shared disputeStatus enum (the complaint API reuses the same 10-value
// enum as chargebacks) so the chip never falls back to an unstyled raw string,
// even for values this admin's own actions never produce.
export const COMPLAINT_STATUS = {
  OPEN: { label: "Open", bg: "#fffbeb", color: "#92400e" },
  INITIATED: { label: "Initiated", bg: "#fffbeb", color: "#92400e" },
  RESPONSE_NEEDED: { label: "Response Needed", bg: "#fffbeb", color: "#92400e" },
  UNDER_REVIEW: { label: "Under Review", bg: "#eff6ff", color: "#1e40af" },
  NO_RESPONSE: { label: "No Response", bg: "#f3f4f6", color: "#374151" },
  ACCEPTED: { label: "Accepted", bg: "#ecfdf5", color: "#065f46" },
  CLOSED: { label: "Resolved", bg: "#ecfdf5", color: "#065f46" },
  MERCHANT_WON: { label: "Merchant Won", bg: "#ecfdf5", color: "#065f46" },
  CUSTOMER_WON: { label: "Customer Won", bg: "#ecfdf5", color: "#065f46" },
  REJECTED: { label: "Rejected", bg: "#fef2f2", color: "#991b1b" },
};

export const COMPLAINT_TYPE_LABEL = {
  AUTHCOMPLAINT: "Auth Complaint",
  FRAUD: "Fraud",
  OTHERS: "Other",
  CHARGEBACK: "Chargeback",
};

export const complaintTypeOptions = [
  { label: "Auth Complaint", value: "AUTHCOMPLAINT" },
  { label: "Fraud", value: "FRAUD" },
  { label: "Other", value: "OTHERS" },
];

export const ChargebacksSummary = [
  {
    title: "Total Chargebacks",
    objKeyRepr: "totalCount",
    icon: <GavelOutlinedIcon fontSize="small" />,
  },
  {
    title: "Awaiting Merchant",
    objKeyRepr: "awaitingResponseCount",
    icon: <HourglassEmptyOutlinedIcon fontSize="small" color="warning" />,
  },
  {
    title: "Ready For Review",
    objKeyRepr: "merchantRespondedCount",
    icon: <RateReviewOutlinedIcon fontSize="small" color="primary" />,
  },
  {
    title: "Resolved",
    objKeyRepr: "resolvedCount",
    icon: <CheckCircleOutlineIcon fontSize="small" color="success" />,
  },
];

export const ComplaintsSummary = [
  {
    title: "Total Complaints",
    objKeyRepr: "totalCount",
    icon: <ReceiptLongOutlinedIcon fontSize="small" />,
  },
  {
    title: "Open",
    objKeyRepr: "openCount",
    icon: <HourglassEmptyOutlinedIcon fontSize="small" color="warning" />,
  },
  {
    title: "Resolved",
    objKeyRepr: "resolvedCount",
    icon: <CheckCircleOutlineIcon fontSize="small" color="success" />,
  },
  {
    title: "Rejected",
    objKeyRepr: "rejectedCount",
    icon: <CancelOutlinedIcon fontSize="small" color="error" />,
  },
];

export const chargebackStatusOptions = Object.entries(CHARGEBACK_STATUS).map(
  ([value, { label }]) => ({ label, value }),
);

export const complaintStatusOptions = Object.entries(COMPLAINT_STATUS).map(
  ([value, { label }]) => ({ label, value }),
);
